import {memo} from 'react';

import {PriceLabel} from '~/shared/components/PriceLabels';

import {PriceWrapper, CancelLabel} from './styled';

const PRICE_WIDTH = 80;

const Price = ({price, isBold, isCanceled, t, dataTestId}) => (
  <PriceWrapper isBold={isBold} width={PRICE_WIDTH} data-test-id={dataTestId}>
    {!isCanceled && <PriceLabel price={price} bold={isBold} />}
    {isCanceled && <CancelLabel isBold={isBold}>{t('cancelled')}</CancelLabel>}
  </PriceWrapper>
);

export default memo(Price);
